module.exports = __webpack_public_path__ + "static/media/IUP_zast_L2.cb3bb870.svg";